import { create } from 'zustand'
import { User, CreateUserDto, UpdateUserDto } from '@/types'
import { usersService } from '@/services/users.service'

interface AttachedResellersState {
  resellers: User[] | null
  isInitialized: boolean
  fetchAttachedResellers: (force?: boolean) => Promise<void>
  fetchAttachedResellersByWholesaler: (wholesaler: string) => Promise<User[]>
  addAttachedReseller: (user: CreateUserDto) => Promise<User>
  updateAttachedReseller: (id: string, user: UpdateUserDto) => Promise<User>
  deleteAttachedReseller: (id: string) => Promise<void>
}

export const useAttachedResellersStore = create<AttachedResellersState>((set, get) => ({
  resellers: null,
  isInitialized: false,

  fetchAttachedResellers: async (force = false) => {
    if (get().isInitialized && !force) return
    const data = await usersService.getAttachedResellers()
    set({ resellers: data, isInitialized: true })
  },

  fetchAttachedResellersByWholesaler: async (wholesaler: string) => {
    return usersService.getAttachedResellers({ wholesaler })
  },

  addAttachedReseller: async (userData: CreateUserDto) => {
    const newUser = await usersService.create(userData)
    set(state => ({ resellers: [...(state.resellers || []), newUser] }))
    return newUser
  },

  updateAttachedReseller: async (id: string, userData: UpdateUserDto) => {
    const updatedUser = await usersService.update(id, userData)
    set(state => ({
      resellers: state.resellers?.map(u => (u._id === id ? updatedUser : u)),
    }))
    return updatedUser
  },

  deleteAttachedReseller: async (id: string) => {
    await usersService.delete(id)
    set(state => ({
      resellers: state.resellers?.filter(u => u._id !== id),
    }))
  },
}))
